import { render, staticRenderFns } from "./RegisterHomelyRemedies.vue?vue&type=template&id=28f221bf&scoped=true"
import script from "./RegisterHomelyRemedies.vue?vue&type=script&lang=js"
export * from "./RegisterHomelyRemedies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f221bf",
  null
  
)

export default component.exports